import React, { Component } from "react";
import Slide from "../Dashboard/Slide";
import { connect } from "react-redux";
class SlideDisposition extends Component {
  render() {
    return (
      <Slide
        key="1"
        slide={this.props.Slide}
        comments={this.props.comments}
        isResponsive={false}
        isComposition={true}
        isPresentation={false}
        isPreparePresentation={false}
        removeComponent={this.props.HandleRemoveComponent}
        updateComponent={this.props.HandleUpdateComponent}
        explanations={this.props.indicatorsExplanation}
        indicators={this.props.suggestions}
      />
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  fetchedSlide: state.slideComposition.slide,
  fetched: state.slideComposition.fetchSlide.fetched,
  fetching: state.slideComposition.fetchSlide.fetching,
  indicatorsExplanation: state.indicatorsExplanation.items,
  suggestions: state.indicators.suggestions.items
});

export default connect(mapStateToProps)(SlideDisposition);



// WEBPACK FOOTER //
// ./src/components/SlideComposition/SlideDisposition.js